<template>
  <v-btn icon small width="38px" height="38px" @click="$emit('click')">
    <v-icon size="20" color="white">
      <slot></slot>
    </v-icon>
  </v-btn>
</template>

<script>
export default {
  name: "IconBtn"
};
</script>

<style scoped>
</style>